import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Alert } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';

/**
 * Generated class for the EditscontiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-editsconti',
  templateUrl: 'editsconti.html',
})
export class EditscontiPage {
  orario;
  errorMessage;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,

    ) {
    this.orario=navParams.get('orario');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditscontiPage');
  }
updateOrario(data){
  this.rest.aggiornaGiornoConsegna(data).subscribe(
    res => {
     alert("Aggiornato con successo");

    },
    error => this.errorMessage = <any>error);
}
}



// WEBPACK FOOTER //
// ./src/pages/editsconti/editsconti.ts